import { render, staticRenderFns } from "./myHome.vue?vue&type=template&id=688a24dc&scoped=true&"
import script from "./myHome.vue?vue&type=script&lang=js&"
export * from "./myHome.vue?vue&type=script&lang=js&"
import style0 from "./myHome.vue?vue&type=style&index=0&id=688a24dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688a24dc",
  null
  
)

export default component.exports